import { c as _c } from "react/compiler-runtime";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { useDropForgeManifoldClaim } from "@/hooks/useDropForgeManifoldClaim";
import type { ManifoldClaimStatus } from "@/hooks/useManifoldClaim";
import { useNowMinting } from "@/hooks/useNowMinting";
type NowMintingStatus = {
  readonly nft: NFTWithMemesExtendedData | undefined;
  readonly isFetching: boolean;
  readonly status: ManifoldClaimStatus | null;
  readonly isDropComplete: boolean;
  readonly isStatusLoading: boolean;
  readonly error: unknown;
};
export const useNowMintingStatus = () => {
  const $ = _c(7);
  const {
    nft,
    isFetching,
    error
  } = useNowMinting();
  const {
    claim
  } = useDropForgeManifoldClaim(nft?.id ?? -1);
  const t0 = claim?.status ?? null;
  const t1 = claim?.isDropComplete ?? false;
  const t2 = !!nft && !claim;
  let t3;
  if ($[0] !== error || $[1] !== isFetching || $[2] !== nft || $[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      nft,
      isFetching,
      status: t0,
      isDropComplete: t1,
      isStatusLoading: t2,
      error
    };
    $[0] = error;
    $[1] = isFetching;
    $[2] = nft;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};